import { put } from 'redux-saga/effects';
import { get } from 'lodash';

export function* onOpenModal(modals, action) {
  const type = get(action, 'payload.type');
  const data = get(action, 'payload.data');

  if (modals[type] && modals[type].onOpen) {
    yield put(
      modals[type].onOpen({
        data,
      })
    );
  }
}
